import { useState, useRef } from "react";
import { LUNCH_URL, DISPLAY_URL } from "../../../../actions/api";
import { useSelector,shallowEqual } from "react-redux";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

const LaunchDisplay = (props) => {

    const [copyTooltip, setcopyTooltip] = useState(false);
    const [copyData, setcopyData] = useState(false);
    const { userData } = useSelector(state=>state.authenticated,shallowEqual);    
    const wallKey = userData?.user?.user_key ?? '';
    const publicAccess = props.wallData?.wall?.Personalization?.publicAccess ?? 0;
    const wallId = localStorage.getItem('wallId');
    const url = `${DISPLAY_URL}/${wallId}${publicAccess ? `?wallKey=${wallKey}` : ""}${props.lunchUrlParm}`;

    const LinkRef = useRef();

    const copyCode = (data) => {
        navigator.clipboard.writeText(LinkRef.current.value)
        setcopyTooltip(true);
        setTimeout(() => {
            setcopyTooltip(false);
            document.getSelection().removeAllRanges();
        }, 1000);
        setcopyData(true)
        setTimeout(() => setcopyData(false), 500);
    }

    return (

        props.lunch == 1 ?
            <div className="d-flex align-items-start flex-wrap">
                <div className="mb-3 d-flex flex-column overflow-hidden">
                    <p className="position-relative mb-0">
                        <input readOnly="readOnly" type="text" className="form-control form-control-lg me-3 w-auto overflow-hidden text-ellipsis text-nowrap" value={url} style={{ minWidth: '25vw' }} data-factors-input-id="noform.field-12" ref={LinkRef} onClick={(e) => { copyCode(1) }} />
                        <span id="copy-success-alert" style={{ display: copyTooltip ? 'block' : 'none' }}>Copied to clipboard</span>
                    </p>
                    <span className="text-muted">Display URL </span>
                </div>

                <a href={url} target="_blank" className="btn btn-dark btn-lg py-3 f-center" data-factors-click-bind="true">
                    <FontAwesomeIcon type={'regular'} icon={'display'} iconClass={'me-1'} />  Launch Display
                </a>
            </div> :

            (props.lunch == 2 ?

                <div className="form-group mb-6 mb-lg-10 display_id">
                    <ul className="p-0 d-flex align-items-center list-inline mb-0">
                        {wallId.split('').map((x) => {
                            return (<li><span>{x}</span></li>)
                        })}
                    </ul>
                    <span className="text-muted">Display Code </span>
                </div>
                :
                (props.lunch == 3 ?

                    <div className="form-group mb-6 mb-lg-10 display_id">
                        <div className="d-flex align-items-start flex-wrap">
                            <div className="mb-3 d-flex flex-column overflow-hidden">
                                <p className="position-relative mb-0">
                                    <input ref={LinkRef} onClick={(e) => { copyCode(1) }} readOnly="readonly" type="text" className="text-center form-control me-3 bg-light font-weight-boldest font-size-h1 border py-2 h-auto copyDisplayCode" value={wallId} style={{ width: `${200}px`, letterSpacing: '13px', lineHeight: 1 }} data-factors-input-id="noform.field-18" />
                                    <span id="copy-success-alert" style={{ display: copyTooltip ? 'block' : 'none' }}>Copied to clipboard</span>
                                </p>
                                <span className="text-muted">Display Code</span>
                            </div>
                            <a href="javascript:;" onClick={(e) => { copyCode(2) }} className="btn btn-primary btn-lg copyDisplayCodeEvent" data-factors-click-bind="true">
                                {copyData ? 'Copied' : 'Copy Code'}
                            </a>
                        </div>
                    </div>
                    :
                    <div className={`d-flex align-items-start ${!props.removeClass ? `flex-wrap ms-5` : ``} `}>
                        <div className="mb-3 d-flex flex-column overflow-hidden">
                            <p className="position-relative mb-0">
                                <input readOnly="readonly" ref={LinkRef} onClick={(e) => { copyCode(1) }} type="text" className="form-control form-control-lg me-3 w-auto overflow-hidden text-ellipsis text-nowrap virtual-embed-iframe" data-factors-input-id="noform.field-24"
                                    value={`${LUNCH_URL}${wallId}?editor=1&webembed=1${publicAccess ? `&wallKey=${wallKey}` : ""}`} style={{ minWidth: '25vw' }} />

                                <span id="copy-success-alert" style={{ display: copyTooltip ? 'block' : 'none' }}>Copied to clipboard</span>
                            </p>
                            <span className="text-muted">Display URL</span>
                        </div>
                        <a onClick={(e) => { copyCode(2) }} href="javascript:;" className="btn btn-primary btn-lg copy-virtual-event f-center" data-factors-click-bind="true">
                            <FontAwesomeIcon type={'regular'} icon={'copy'} iconClass={'me-1'} />
                            Copy Url
                        </a>
                    </div>

                )
            )

    )
}



export default LaunchDisplay